// ** React Imports
import { lazy } from 'react'

const Asesorias = lazy(() => import('../../views/pages/asesorias'))
import AsesoriasPublicasForm from "@pages/asesorias/forms/AsesoriasPublicasForm"

const AsesoriasRoutes = [
  {
    element: <Asesorias />,
    path: '/asesorias/lista',
    meta: {
      appLayout: false,
      className: 'email-application'
    }
  },
  {
    path: '/asesorias-publicas/:asesoria/:idProspecto/:idUsuario',
    element: <AsesoriasPublicasForm />,
    meta: {
      publicRoute: true,
      layout: 'blank',
      appLayout: 'blank'
    }
  }
]

export default AsesoriasRoutes
